import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import _ from 'lodash';

const INITIAL_STATE = {
  'loading': false,
  'internalsOrdersList': [],
  'internalsOrdersListByPage': [],
  'pageSize': 20,
  'pageNumber': 0,
  'deleting': false,
  'creating': false,
  'internalOrderToEdit': {},
};

const FORM_INITIAL_STATE = {
  'elements': [],
};

const addCheckedField = (list) => {
  const newList = [...list];
  newList.map((element) => {
    return element.checked = true;
  });
  return newList;
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

const removeOrder = (internalsOrdersList, {orderCode, returnToList}) => {
  const ordersList = [...internalsOrdersList];
  if (returnToList) {
    return ordersList;
  }
  const positionOrderToDelete = _.findIndex(ordersList, (order) => {
    return order.code === orderCode;
  });
  if (positionOrderToDelete > -1) {
    ordersList.splice(positionOrderToDelete, 1);
  }
  return ordersList;
};

const changeCheckedStatus = (list, orderCode, checked) => {
  const newList = [...list];
  const index = _.findIndex(newList, function(element) {
    return element.code === orderCode;
  });

  const newObject = {...newList[index]};
  newObject.checked = checked;
  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
};

function addItemSavedFieldToItems(items) {
  return items.map((element) => {
    const priceFormatted = element.price.toFixed(2);
    const subTotal = (element.quantity * element.price).toFixed(2);
    
    return {...element, subTotal, 'price': priceFormatted, 'itemSaved': true};
  });
}

function addInfoToItem(list, index, lineInfo) {
  const newList = [...list];
  let newObject = {...newList[index]};
  newObject = lineInfo;
  const priceFormatted = parseFloat(lineInfo.price).toFixed(2);
  newObject.price = priceFormatted;
  newObject.partChecked = true;

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

function getItemsWithoutLineInfo(list, index) {
  const newList = [...list];
  let newObject = {...newList[index]};
  const partCode = newObject.partCode;
  newObject = {};
  newObject.partCode = partCode;
  newObject.partChecked = false;

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

function updateSubTotal(list, {index, quantity, price}) {
  const newList = [...list];
  const newObject = {...newList[index]};

  if (quantity) {
    newObject.quantity = parseInt(quantity, 10);
  }

  if (price) {
    newObject.price = Number(price);
  }

  const subTotal = newObject.price * newObject.quantity;
  newObject.subTotal = subTotal.toFixed(2);

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

function saveItem(list, lineInfo, index) {
  const newList = [...list];
  newList.push({'partCode': '', 'partChecked': false});

  const newObject = {...newList[index]};
  newObject.itemSaved = true;
  
  return [...newList.slice(0, index), newObject, ...newList.slice(index + 1)];
}

const removeItemFromOrder = (list, index) => {
  const ordersList = [...list];
  ordersList.splice(index, 1);
  
  return ordersList;
};

const updateItemFromOrder = (list, {index, name, value}) => {
  const element = {...list[index], [name]: value};
  
  return [...list.slice(0, index), element, ...list.slice(index + 1)];
};

export const internalOrder = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_INTERNALS_ORDERS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_INTERNALS_ORDERS_LIST]: (state, action) => {
      const newList = addCheckedField(action.response.data);
      return ({
        ...state,
        'loading': false,
        'internalsOrdersList': newList,
        'internalsOrdersListByPage': [...getPage(newList, 0, state.pageSize)],
      });
    },
    [ActionTypes.FETCHED_INTERNALS_ORDERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'internalsOrdersList': [],
      'internalsOrdersListByPage': [],
    }),
    [ActionTypes.CHANGE_INTERNALS_ORDERS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'internalsOrdersListByPage': [...getPage(state.internalsOrdersList, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_INTERNALS_ORDERS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'internalsOrdersListByPage': [...getPage(state.internalsOrdersList, 0, action.payload)],
    }),
    [ActionTypes.EMPTY_ORDERS_DATA]: (state, action) => ({
      ...state,
      'loading': false,
      'creating': false,
      'pageNumber': 0,
      'internalsOrdersList': [],
      'internalsOrdersListByPage': [],
    }),
    [ActionTypes.DELETING_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'deleting': true,
    }),
    [ActionTypes.DELETED_INTERNAL_ORDER]: (state, action) => {
      const newList = removeOrder(state.internalsOrdersList, action.payload);
      return ({
        ...state,
        'deleting': false,
        'internalsOrdersList': newList,
        'internalsOrdersListByPage': [...getPage(newList, state.pageNumber, state.pageSize)],
      });
    },
    [ActionTypes.DELETED_INTERNAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'deleting': false,
    }),
    [ActionTypes.CLEAR_INTERNAL_ORDER_FORM]: (state, action) => ({
      ...state,
      'creating': false,
      'deleting': false,
      'internalOrderToEdit': {},
    }),
    [ActionTypes.CREATING_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'creating': true,
    }),
    [ActionTypes.CREATED_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'creating': false,
      'internalOrderToEdit': action.response.data,
    }),
    [ActionTypes.CREATED_INTERNAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'creating': false,
      'internalOrderToEdit': {},
    }),
    [ActionTypes.FETCHING_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_INTERNAL_ORDER]: (state, action) => {
      const orderData = {...action.response.data};
      delete orderData.detail;
      return ({
        ...state,
        'loading': false,
        'internalOrderToEdit': orderData,
      });
    },
    [ActionTypes.FETCHED_INTERNAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'internalOrderToEdit': {},
    }),
    [ActionTypes.ADDING_ITEM_TO_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'creating': true,
    }),
    [ActionTypes.ADDED_ITEM_TO_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'creating': false,
    }),
    [ActionTypes.ADDED_ITEM_TO_INTERNAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'creating': false,
    }),
    [ActionTypes.DELETING_ITEM_FROM_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'deleting': true,
    }),
    [ActionTypes.DELETED_ITEM_FROM_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'deleting': false,
    }),
    [ActionTypes.DELETED_ITEM_FROM_INTERNAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'deleting': false,
    }),
    [ActionTypes.ADD_ORDER_CODE_TO_INVOICE]: (state, action) => {
      const newList = changeCheckedStatus(state.internalsOrdersList, action.payload, true);

      return ({
        ...state,
        'internalsOrdersList': newList,
        'internalsOrdersListByPage': [...getPage(newList, state.pageNumber, state.pageSize)],
      });
    },
    [ActionTypes.REMOVE_ORDER_CODE_TO_INVOICE]: (state, action) => {
      const newList = changeCheckedStatus(state.internalsOrdersList, action.payload, false);

      return ({
        ...state,
        'internalsOrdersList': newList,
        'internalsOrdersListByPage': [...getPage(newList, state.pageNumber, state.pageSize)],
      });
    },
  })(state, action);
};

export const internalOrderForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.UPDATE_ITEM_VALUE_FROM_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'elements': updateItemFromOrder(state.elements, action.payload),
    }),
    [ActionTypes.CLEAR_INTERNAL_ORDER_FORM]: (state, action) => ({
      ...state,
      'elements': [],
    }),
    [ActionTypes.CREATED_INTERNAL_ORDER]: (state, action) => ({
      ...state,
      'elements': [{'partCode': '', 'partChecked': false}],
    }),
    [ActionTypes.FETCHED_INTERNAL_ORDER]: (state, action) => {
      const {detail} = action.response.data;
      const newList = addItemSavedFieldToItems(detail);
      newList.push({'partCode': '', 'partChecked': false});

      return ({
        ...state,
        'elements': newList,
      });
    },
    [ActionTypes.VERIFIED_STOCK_IN_WAREHOUSE]: (state, action) => ({
      ...state,
      'elements': addInfoToItem(state.elements, action.payload, action.response.data),
    }),
    [ActionTypes.VERIFIED_STOCK_IN_WAREHOUSE_FAILED]: (state, action) => ({
      ...state,
      'elements': getItemsWithoutLineInfo(state.elements, action.payload),
    }),
    [ActionTypes.UPDATE_SUBTOTAL]: (state, action) => ({
      ...state,
      'elements': updateSubTotal(state.elements, action.payload),
    }),
    [ActionTypes.ADDED_ITEM_TO_INTERNAL_ORDER]: (state, action) => {
      const index = action.payload;
      const lineInfo = action.response.data;

      return ({
        ...state,
        'elements': saveItem(state.elements, lineInfo, index),
      });
    },
    [ActionTypes.DELETED_ITEM_FROM_INTERNAL_ORDER]: (state, action) => {
      const newItems = removeItemFromOrder(state.elements, action.payload);
      return ({
        ...state,
        'elements': newItems,
      });
    },
  })(state, action);
};
